var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Firmware-version" },
    [
      _c("pageTitle", _vm._b({}, "pageTitle", { ..._vm.pT }, false)),
      _c(
        "business-group",
        {
          ref: "businessGroup",
          attrs: {
            tableConfig: { ..._vm.tableConfig },
            formConfig: { ..._vm.formConfig },
          },
          scopedSlots: _vm._u([
            {
              key: "formSlot",
              fn: function (formSlot) {
                return [
                  _c(
                    "a-form-item",
                    [
                      _c(
                        "a-select",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["type"],
                              expression: "['type']",
                            },
                          ],
                          staticStyle: { width: "150px" },
                          attrs: { placeholder: "请选择固件类型" },
                        },
                        _vm._l(_vm.firmwareTypeMap, function (el) {
                          return _c(
                            "a-select-option",
                            { key: el.value, attrs: { value: el.value } },
                            [_vm._v(_vm._s(el.label))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["name"],
                            expression: "['name']",
                          },
                        ],
                        staticStyle: {
                          width: "250px",
                          "margin-right": "10px",
                          "vertical-align": "middle",
                        },
                        attrs: { placeholder: "请输入固件名称" },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
            {
              key: "firmwareType",
              fn: function (record) {
                return [
                  _vm._v(" " + _vm._s(_vm.firmwareType[record.type]) + " "),
                ]
              },
            },
            {
              key: "releaseDate",
              fn: function (record) {
                return [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.dataFormatStr(record.releaseDate, "YYYY-MM-DD")
                      ) +
                      " "
                  ),
                ]
              },
            },
            {
              key: "createTime",
              fn: function (record) {
                return [
                  _vm._v(
                    " " + _vm._s(_vm.dataFormatStr(record.createTime)) + " "
                  ),
                ]
              },
            },
            {
              key: "updateTime",
              fn: function (record) {
                return [
                  _vm._v(
                    " " + _vm._s(_vm.dataFormatStr(record.updateTime)) + " "
                  ),
                ]
              },
            },
            {
              key: "lang",
              fn: function (record) {
                return [
                  _vm._v(" " + _vm._s(_vm.getLangShow(record.lang)) + " "),
                ]
              },
            },
            {
              key: "download",
              fn: function (record) {
                return [
                  _c(
                    "a",
                    { attrs: { href: record.downloadUrl, target: "_blank" } },
                    [_vm._v("下载")]
                  ),
                ]
              },
            },
            {
              key: "action",
              fn: function (record) {
                return [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "link" },
                      on: {
                        click: function ($event) {
                          return _vm.edit(record)
                        },
                      },
                    },
                    [_vm._v("编辑")]
                  ),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "link" },
                      on: {
                        click: function ($event) {
                          return _vm.del(record)
                        },
                      },
                    },
                    [_vm._v("删除")]
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "formRight" },
            [
              _c(
                "a-button",
                { attrs: { type: "primary" }, on: { click: _vm.add } },
                [_vm._v("新增")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.visible,
            title: _vm.title,
            destroyOnClose: "",
            maskClosable: false,
            width: "800px",
          },
          on: {
            ok: function ($event) {
              return _vm.submitForm("ruleForm")
            },
            cancel: function ($event) {
              return _vm.resetForm("ruleForm")
            },
          },
        },
        [
          _c(
            "a-form-model",
            {
              ref: "ruleForm",
              staticClass: "Firmware-version_ruleForm",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-col": { span: 7 },
                "wrapper-col": { span: 14 },
              },
            },
            [
              _c(
                "a-form-model-item",
                { attrs: { label: "固件名", prop: "name" } },
                [
                  _c("a-input", {
                    attrs: {
                      type: "text",
                      placeholder: "请输入固件名",
                      "max-length": 64,
                    },
                    model: {
                      value: _vm.ruleForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "name", $$v)
                      },
                      expression: "ruleForm.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "版本号", prop: "version" } },
                [
                  _c("a-input", {
                    attrs: {
                      type: "text",
                      placeholder: "请输入版本号 vx.x.x",
                      "max-length": 16,
                    },
                    model: {
                      value: _vm.ruleForm.version,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "version", $$v)
                      },
                      expression: "ruleForm.version",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "固件类型", prop: "type" } },
                [
                  _c(
                    "a-select",
                    {
                      attrs: { placeholder: "请选择固件类型" },
                      model: {
                        value: _vm.ruleForm.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "type", $$v)
                        },
                        expression: "ruleForm.type",
                      },
                    },
                    _vm._l(_vm.firmwareTypeMap, function (el) {
                      return _c(
                        "a-select-option",
                        { key: el.value, attrs: { value: el.value } },
                        [_vm._v(" " + _vm._s(el.label) + " ")]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "发布日期", prop: "releaseDate" } },
                [
                  _c("a-date-picker", {
                    attrs: { format: _vm.dateFormat },
                    model: {
                      value: _vm.ruleForm.releaseDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "releaseDate", $$v)
                      },
                      expression: "ruleForm.releaseDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "语言", prop: "lang" } },
                [
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "150px" },
                      attrs: { placeholder: "请选择语言", "show-search": "" },
                      model: {
                        value: _vm.ruleForm.lang,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "lang", $$v)
                        },
                        expression: "ruleForm.lang",
                      },
                    },
                    _vm._l(_vm.langs, function (el) {
                      return _c(
                        "a-select-option",
                        { key: el.value, attrs: { value: el.value } },
                        [_vm._v(" " + _vm._s(el.label) + " ")]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "版本信息", prop: "versionImformation" } },
                [
                  _c("a-textarea", {
                    attrs: {
                      placeholder: "请输入版本信息",
                      rows: 4,
                      maxLength: 2048,
                    },
                    model: {
                      value: _vm.ruleForm.versionImformation,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "versionImformation", $$v)
                      },
                      expression: "ruleForm.versionImformation",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "版本详细说明（富文本）",
                    prop: "versionDetailRichText",
                  },
                },
                [
                  _vm.visible
                    ? _c("edit-components", {
                        attrs: {
                          content: _vm.ruleForm.versionDetailRichText,
                          "html-change": _vm.onVersionDetailRichTextChange,
                          uploadImg: _vm.uploadRichTextImg,
                          "upload-path": _vm.richTextUploadPath,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "上传固件", prop: "downloadUrl" } },
                [
                  _c(
                    "a-upload",
                    {
                      staticClass: "m-upload",
                      attrs: {
                        name: "downloadUrl",
                        "before-upload": _vm.beforeUpload,
                        remove: _vm.remove,
                        "file-list": _vm.files,
                        disabled: !_vm.nowTitleIsNew,
                      },
                      model: {
                        value: _vm.ruleForm.downloadUrl,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "downloadUrl", $$v)
                        },
                        expression: "ruleForm.downloadUrl",
                      },
                    },
                    [
                      _vm.files.length <= 0
                        ? _c("a-icon", {
                            attrs: { type: _vm.upLoading ? "loading" : "plus" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }